// Fallback image shown when a property's hero photo fails to load.
// Domain-specific — never reach for this from outside the property/portfolio/orders cards;
// callers consume via `@modules/offerings` re-export.
export const PROPERTY_IMAGE_PLACEHOLDER =
  'https://placehold.co/800x500/e9eaeb/717680?text=Property+Image'
